import { render, staticRenderFns } from "./EditPageDetails.vue?vue&type=template&id=a36449f0&"
import script from "./EditPageDetails.vue?vue&type=script&lang=js&"
export * from "./EditPageDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports